import styles from './ExportVideo.module.css';

const ExportVideoStart = () => {
  return (
    <div className={styles.exportVideoStart}>
      <p>
        By clicking the button below, you'll initiate the export of your giide
        into a video format.{' '}
        <b>
          Please note that, unlike giides, videos do not offer interactivity and
          currently do not support GIF playback.
        </b>{' '}
        This process may take up to several minutes to complete, and as soon as
        your video is ready, we'll notify you.
      </p>
    </div>
  );
};

export default ExportVideoStart;
